import useReports from "./hook/useReports";
import TableHeadings from '../../components/Common-components/table-headings'
import { imageBaseUrl } from "../../components/Constant";
import { Spinner } from '../../components/Common-components/spinner';
import { getFullAddress } from "../../utils";
import TableContainer from "./component/tableContainer";
import moment from "moment-timezone";
import { Avatar } from "@mui/material";
import { useTranslation } from "react-i18next";


const Booking = () => {
    const {
        BookingTableHead,
        details,
        loader,
        controller,
        totalCount,
        handlePagination,
    } = useReports();
    const { t } = useTranslation();
    return (
        <>
            {loader && <Spinner />}
            <TableContainer handlePagination={handlePagination} data={details} totalCount={totalCount} title={`${t("boxTitle.booking")}`} controller={controller}>
                <table className="table ">
                    <TableHeadings removeTr={true} TableHeadData={BookingTableHead} />
                    <tbody>
                        {details?.map((cur, index) => (
                            <>
                                <tr className='fw-4 font-12' key={cur?._id} >
                                    {/* <td className="">
                                        <Avatar alt={cur?.clientName} src={`${imageBaseUrl}profile/thumbnail/${cur?.clientImage}`} />
                                    </td> */}
                                    <td>{cur?.bookingReferenceNumber}</td>
                                    <td>{cur?.clientName ?? "-"}</td>
                                    <td >{moment(cur?.dateOfBooking).format("ll")}</td>
                                    <td>{cur?.allServices ?? "-"}</td>
                                    <td>{cur?.amount ?? "-"}</td>
                                    <td>{cur?.amountToReceived ?? "-"}</td>
                                    <td>{cur?.amountGetFromAdmin ?? "-"}</td>
                                    <td>{cur?.amountToBePaid ?? "-"}</td>
                                    <td>{cur?.commissionCharges ?? "-"}</td>
                                    <td>{getFullAddress(cur?.clientAddress)}</td>
                                    <td>{getFullAddress(cur?.vendorAddress)}</td>
                                    <td>{cur?.extraCharges ?? "-"}</td>
                                </tr>
                                <tr className='default_tr_gap'> </tr>
                            </>

                        ))}
                    </tbody>
                </table>
            </TableContainer>
        </>

    )
}

export default Booking
